import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Text } from '@chakra-ui/react';
import { formatDataTestId, renderSanitizedHtml, ternaryCondition, useCustomLocale } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import React from 'react';
import Info from '../Icon';
import Notification from '../Notification';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function FailConfirmation(_ref) {
  var data = _ref.data,
    t = _ref.t;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var baseDataTestId = 'FailConfirmation';
  var _useRouter = useRouter(),
    query = _useRouter.query;
  if (!data) {
    return null;
  }
  var emailAddress = data.emailAddress,
    bookingReference = data.bookingReference,
    notificationText = data.notificationText,
    paymentOption = data.paymentOption,
    _data$sendMail = data.sendMail,
    sendMail = _data$sendMail === void 0 ? true : _data$sendMail,
    _data$isCcui = data.isCcui,
    isCcui = _data$isCcui === void 0 ? false : _data$isCcui,
    _data$isGermanHotel = data.isGermanHotel,
    isGermanHotel = _data$isGermanHotel === void 0 ? false : _data$isGermanHotel;
  var updateEmailMessage = ternaryCondition(isCcui, ternaryCondition(sendMail, t('booking.confirmation.updateEmailMessage').replace('[emailAddress]', emailAddress), ternaryCondition(language !== 'de', t('ccui.booking.confirmation.bookingErrorMessage.reservedWithCard.PI'), '')), t('booking.confirmation.updateEmailMessage').replace('[emailAddress]', emailAddress));
  var payNowUpdateEmailMsg = ternaryCondition(paymentOption === 'PAY_NOW', ternaryCondition(isCcui, t('ccui.booking.confirmation.bookingErrorMessage.payNow'), t('booking.confirmation.paymentMessage')), '');
  var bookingErrorMsgPOA = ternaryCondition(isGermanHotel, t('ccui.booking.confirmation.bookingErrorMessage.reservedWithCard.PID'), t('ccui.booking.confirmation.bookingErrorMessage.reservedWithCard.PI'));
  return _jsxs(_Fragment, {
    children: [_jsx(Text, _objectSpread(_objectSpread({}, titleStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title-Name'),
      children: (query === null || query === void 0 ? void 0 : query['secure-booking']) === 'true' ? t('nonguaranteed.booking.secureBookingError') : t('booking.confirmation.sorry')
    })), sendMail ? _jsx(Text, {
      "data-testid": formatDataTestId(baseDataTestId, 'Email'),
      fontSize: "md",
      children: renderSanitizedHtml(updateEmailMessage + ' ' + payNowUpdateEmailMsg)
    }) : _jsx(Text, {
      "data-testid": formatDataTestId(baseDataTestId, 'BookingErrorMsgPOA'),
      fontSize: "md",
      children: bookingErrorMsgPOA
    }), _jsx(Divider, {
      my: "2xl"
    }), _jsx(Text, _objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'Label')
    }, bookingRefLabelStyle), {}, {
      children: t('ccui.booking.confirmation.reference')
    })), _jsx(Text, _objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'Id')
    }, bookingRefStyle), {}, {
      children: bookingReference
    })), _jsx(Box, {
      mb: "lg",
      "data-testid": formatDataTestId(baseDataTestId, 'Notification'),
      children: _jsx(Notification, {
        maxWidth: "full",
        variant: "info",
        status: "info",
        description: notificationText,
        svg: _jsx(Info, {})
      })
    })]
  });
}
var titleStyle = {
  fontSize: '3xxl',
  fontWeight: 'semibold',
  mb: 'md'
};
var bookingRefLabelStyle = {
  mb: 'xs',
  fontSize: 'lg',
  fontWeight: 'bold'
};
var bookingRefStyle = {
  mb: 'lg',
  fontSize: '2xl'
};